// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { initFlowbite } from 'flowbite'

// Reinitialize Flowbite after Turbo navigation
// This ensures modals, dropdowns, and other Flowbite components work after Turbo page transitions
document.addEventListener('turbo:load', () => {
  initFlowbite()
})

document.addEventListener('turbo:render', () => {
  initFlowbite()
})
